module.exports = __webpack_public_path__ + "static/media/CARTA DE MOTIVACION EN INGLES.b3375fd8.docx";